import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ErrorHandler, inject, NgModule, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UrlSerializer } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppRootComponent } from "./app-root.component";
import { VituExceptionHandlerService } from "./vitu-exception-handler.service";
import { LowerCaseUrlSerializer } from "@Shared2/lowercase-router-serializer.service";
import { AngularHttpInterceptorProvider } from "@Shared2/http-interceptors/angular-interceptor";
import { RequestScopeInterceptorProvider } from "@Shared2/http-interceptors/request-scope-interceptor";
import { CacheInterceptorProvider } from "@Shared2/http-interceptors/cache-interceptor";
import { SessionIdInterceptorProvider } from "@Shared2/http-interceptors/session-id-interceptor";
import { pathnameToSolution, SOLUTION } from "./solution";
import { WindowRef } from "@Shared2/window-ref.service";
import { Environment } from "@Infrastructure/Environment";
import { environment } from "environments/environment";
import { NgbConfig, NgbModalConfig, NgbPopoverConfig, NgbTypeaheadConfig } from "@ng-bootstrap/ng-bootstrap";
import { AppConfigService } from "./app-config.service";
import { GlobalEventListenerService } from "@App/global-event-listener.service";
import { CspViolationTracker } from "./csp-violation-tracker.service";

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgSelectModule,
        FormsModule,
    ],
    declarations: [
        AppRootComponent,
    ],
    bootstrap: [
        AppRootComponent,
    ],
    providers: [
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer,
        },
        {
            provide: ErrorHandler,
            useClass: VituExceptionHandlerService,
        },
        {
            provide: SOLUTION,
            useFactory: (windowRef: WindowRef) => pathnameToSolution(windowRef.nativeWindow.location.pathname),
            deps: [WindowRef],
        },
        {
            provide: Environment,
            useFactory: () => new Environment(environment),
        },
        AppConfigService,
        RequestScopeInterceptorProvider,
        CacheInterceptorProvider,
        AngularHttpInterceptorProvider,
        SessionIdInterceptorProvider,
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => {
            inject(GlobalEventListenerService).start();
        }),
    ],
})
export class AppModule {

    constructor(
        ngbConfig: NgbConfig,
        ngbModalConfig: NgbModalConfig,
        ngbPopoverConfig: NgbPopoverConfig,
        ngbTypeaheadConfig: NgbTypeaheadConfig,
        cspViolationTracker: CspViolationTracker,
    ) {

        ngbConfig.animation = false;
        ngbModalConfig.animation = true;
        ngbModalConfig.keyboard = false;
        ngbPopoverConfig.autoClose = "outside";

        ngbTypeaheadConfig.popperOptions = options => {

            options.modifiers.push({
                name: "offset",
                options: { offset: [0, 0] },
            });

            return options;
        };

        cspViolationTracker.trackViolations();
    }
}
